import { render } from "./PaginationList.vue?vue&type=template&id=666a21dc"
import script from "./PaginationList.vue?vue&type=script&lang=js"
export * from "./PaginationList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__